import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b0510c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chips-input" }
const _hoisted_2 = { class: "example-chips" }

import { computed, ref } from 'vue';
  import ChipElement from '@/components/ChipElement.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ChipsInput',
  props: {
    selected: null,
    options: null,
    optionLabel: null,
    placeholder: null
  },
  emits: ["update:selected"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:selected', newValue: any[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selected: any[];
    options: any[];
    optionLabel: string;
    placeholder?: string;
  };

  

  

  const ownChips = ref();

  const updateSelected = (value: any, selected: boolean) => {
    let newSelected = props.selected || [];
    if (selected) {
      newSelected.push(value);
    } else {
      newSelected = newSelected.filter(obj => obj[props.optionLabel] !== value[props.optionLabel]);
    }
    emit('update:selected', newSelected)
  }

  const getAllSelectedChips = () => {
    let allSelected: any[] = [];
    const selected = props.selected || [];
    props.options.forEach(option => {
      if(selected.find(selectedObj => selectedObj.value === option.value)) {
        allSelected.push(option);
      }
    })
    return allSelected
  }

  const removeCustomChip = (removedChip: any) => {
    let allSelected = props.selected;
    const index = allSelected.findIndex((selected) => selected.value === removedChip.value[0]);
    allSelected.splice(index, 1);
    emit('update:selected', allSelected);
  }

  const updateChips = (newChips: Record<string, any>) => {
    let allSelected = getAllSelectedChips();
    newChips.value.forEach((customerChip: string) => {
      allSelected.push({
        displayName: customerChip,
        value: customerChip
      })
    });
    emit('update:selected', allSelected);
  }

  const allSelected = computed(() => props.selected ? props.selected.map(el => el[props.optionLabel]) : []);

return (_ctx: any,_cache: any) => {
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createBlock(ChipElement, {
          key: `chip-${index}`,
          selected: _unref(allSelected).includes(option[props.optionLabel]),
          chip: option,
          optionLabel: props.optionLabel,
          onChipClicked: updateSelected
        }, null, 8, ["selected", "chip", "optionLabel"]))
      }), 128))
    ]),
    _createVNode(_component_Chips, {
      modelValue: ownChips.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ownChips).value = $event)),
      separator: ",",
      placeholder: props.placeholder,
      onAdd: updateChips,
      onRemove: removeCustomChip
    }, null, 8, ["modelValue", "placeholder"])
  ]))
}
}

})